/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutiveAssistantInvitation } from './ExecutiveAssistantInvitation';
import {
    ExecutiveAssistantInvitationFromJSON,
    ExecutiveAssistantInvitationFromJSONTyped,
    ExecutiveAssistantInvitationToJSON,
    ExecutiveAssistantInvitationToJSONTyped,
} from './ExecutiveAssistantInvitation';

/**
 * 
 * @export
 * @interface ExecutiveAssistantInvitationResponse
 */
export interface ExecutiveAssistantInvitationResponse {
    /**
     * 
     * @type {Array<ExecutiveAssistantInvitation>}
     * @memberof ExecutiveAssistantInvitationResponse
     */
    items?: Array<ExecutiveAssistantInvitation>;
}

/**
 * Check if a given object implements the ExecutiveAssistantInvitationResponse interface.
 */
export function instanceOfExecutiveAssistantInvitationResponse(value: object): value is ExecutiveAssistantInvitationResponse {
    return true;
}

export function ExecutiveAssistantInvitationResponseFromJSON(json: any): ExecutiveAssistantInvitationResponse {
    return ExecutiveAssistantInvitationResponseFromJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveAssistantInvitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ExecutiveAssistantInvitationFromJSON)),
    };
}

export function ExecutiveAssistantInvitationResponseToJSON(json: any): ExecutiveAssistantInvitationResponse {
    return ExecutiveAssistantInvitationResponseToJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationResponseToJSONTyped(value?: ExecutiveAssistantInvitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ExecutiveAssistantInvitationToJSON)),
    };
}

